export const SET_RATES = 'changeExam/SET_RATES';
export const SET_EXAMS = 'changeExam/SET_EXAMS';
export const SET_WAITING = 'changeExam/SET_WAITING';
